import React, { useEffect } from "react";
import {
  Card,
  CardContent,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import Div from "@jumbo/shared/Div";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import { useAppMutation } from "../../../services";
import parentServices from "../../../services/parent-services";
import authServices from "../../../services/auth-services";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const steps = ["Contact", "Address", "Finish"];

const Steps = ({ disableSmLogin }) => {
  const {
    mutate,
    data: stepsData,
    isLoading,
  } = useAppMutation(parentServices.loadProfileForSteps);
  const { t } = useTranslation();
  const steps = [
    t("parent.title.contact"),
    t("parent.title.address"),
    t("parent.title.finish"),
  ];
  const [activeStep, setActiveStep] = React.useState(0);
  const [loaded, setLoaded] = React.useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (stepsData) {
      if (!loaded) {
        setLoaded(true);
        if (!stepsData.completedStep1) {
          setActiveStep(0);
        } else if (!stepsData.completedStep2) {
          setActiveStep(1);
        } else if (!stepsData.completedStep3) {
          setActiveStep(2);
        } else {
          setActiveStep(3);
        }
      }

      if (stepsData.completedStep3) {
        authServices.updateAuthUser({
          completedStep3: stepsData.completedStep3,
        });
        window.location = "/dashboard";
      }
    } else {
      mutate();
    }
  }, [stepsData]);

  const handleNext = (step) => {
    // alert(step);

    if (step === 4) {
      mutate();
      setActiveStep(step - 1);
    } else {
      mutate();
      setActiveStep(step - 1);
    }
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Card
      sx={{
        display: "flex",
        minWidth: 0,
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      <CardContent sx={{ flex: 1, p: 4 }}>
        <Div sx={{ width: "100%" }}>
          {/*<Stepper activeStep={activeStep}>
                    {steps.map((label, index) => {
                        const stepProps = {};
                        const labelProps = {};

                        return (<Step key={label} {...stepProps}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                        </Step>);
                    })}
                </Stepper>*/}
          <Div>
            <Typography variant="h2" sx={{ mt: 2, mb: 4, fontWeight: "bold" }}>
              {t("parent-profile.title.newText")}
            </Typography>
          </Div>
          {activeStep === steps.length ? (
            <Div>
              <Typography sx={{ mt: 2, mb: 1, justifyContent: "center" }}>
                All steps completed - you&apos;re finished
              </Typography>
            </Div>
          ) : (
            <Div>
              <Step3 handleNext={handleNext} stepsData={stepsData} />
            </Div>
          )}
        </Div>
      </CardContent>
    </Card>
  );
};

export default Steps;
